var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.791 80.83V38.69V28C105.791 24.134 102.657 21 98.7905 21H84.3106C80.4446 21 77.3105 24.134 77.3105 28V38.69V80.83",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.79 80.8301L134.986 102.041C137.439 103.823 138.466 106.983 137.529 109.867L122.511 156.093C121.574 158.977 118.887 160.93 115.854 160.93H67.2461C64.2133 160.93 61.5256 158.977 60.5886 156.093L45.5713 109.867C44.6344 106.983 45.6611 103.823 48.1144 102.041L77.31 80.8301",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.791 38.6904H77.3105",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.09 111.06H80.0098C76.1438 111.06 73.0098 114.194 73.0098 118.06V119.37C73.0098 123.236 76.1438 126.37 80.0098 126.37H103.09C106.956 126.37 110.09 123.236 110.09 119.37V118.06C110.09 114.194 106.956 111.06 103.09 111.06Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRumIcon);
export default __webpack_public_path__ + "static/media/rum-icon.10a4cc93fb46169c18c703e05dc2accc.svg";
export { ForwardRef as ReactComponent };